<template>
  <div class="d-flex align-items-center justify-content-center min-vh-100" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <CContainer fluid>
      <CRow class="justify-content-center">
        <CCol md="8" lg="6">
          <CCard class="mx-4 mb-0 text-center">
            <CCardBody class="p-5">
              <!-- Loading State -->
              <div v-if="loading">
                <CSpinner class="mb-4" color="primary" />
                <p class="text-muted">Verifying your email…</p>
              </div>

              <!-- Success Message -->
              <div v-if="!loading && success">
                <CIcon name="cil-check-circle" size="4xl" class="mb-4 text-success" />
                <h1 class="h4 font-weight-bold mb-3">Email verified</h1>
                <p class="text-muted mb-4">You can now log in to Niagaku.</p>
                <CButton color="primary" @click="navigateTo('/login')">
                  Go to log in
                </CButton>
              </div>

              <!-- Failure Message -->
              <div v-if="!loading && !success">
                <CIcon name="cil-x-circle" size="4xl" class="mb-4 text-danger" />
                <h1 class="h4 font-weight-bold mb-3">We couldn't verify your email</h1>
                <p class="text-muted mb-4">The link may have expired. Log in to send a new verification email, or contact support.</p>
                <CButton color="secondary" variant="outline" @click="navigateTo('/login')">
                  Go to log in
                </CButton>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>

export default {
  name: "VerifyEmail",
  data() {
    return {
      loading: true,
      success: false,
    };
  },
  mounted() {
    this.verifyEmail();
  },
  methods: {
    navigateTo(path) {
      this.$router.push({ path: path });
    },
    
    verifyEmail() {
      const token = this.$route.query.token;
      const email = this.$route.query.email;

      const verifyDto = {
        email: email,
        token: token,
      };

      // API call to verify email
      auth
        .verifyEmail(verifyDto)
        .then((response) => {
          this.success = true;
        })
        .catch((error) => {
          console.error(error);
          this.success = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.c-icon {
  margin-bottom: 1rem;
}
</style>
